var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoll(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.0663,
    y: 14.7634,
    width: 30,
    height: 30,
    rx: 2.5,
    transform: "rotate(24.2418 18.0663 14.7634)",
    stroke: "currentcolor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5769,
    cy: 26.6651,
    r: 3,
    transform: "rotate(24.2418 22.5769 26.6651)",
    fill: "currentcolor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3426,
    cy: 38.2908,
    r: 3,
    transform: "rotate(24.2418 17.3426 38.2908)",
    fill: "currentcolor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2693,
    cy: 34.9077,
    r: 3,
    transform: "rotate(24.2418 26.2693 34.9077)",
    fill: "currentcolor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2029,
    cy: 31.9003,
    r: 3,
    transform: "rotate(24.2418 34.2029 31.9003)",
    fill: "currentcolor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9685,
    cy: 43.5258,
    r: 3,
    transform: "rotate(24.2418 28.9685 43.5258)",
    fill: "currentcolor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02628 10.3034C7.86631 7.22723 21.4648 2.68902 37.1387 9.14574",
    stroke: "currentcolor",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9707 1.80737L38.9058 10.5798L31.1081 12.2999",
    stroke: "currentcolor",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoll);
export default __webpack_public_path__ + "static/media/Icon_Roll.ab30ba136d8a0fc5daaf18fe3ae95a59.svg";
export { ForwardRef as ReactComponent };